import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ServiceBase } from './service-base.model';
import { UseRoleIDModel } from '../request/UseRoleIDForDto.model';
import { UpdateRoleFunctionsModel } from '../request/UpdateRoleFunctionsForDto.model';
import { UseUserIDModel } from '../request/UseUserIDForDto.model';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { GetUserFunctionPermissionModel } from '../response/GetUserFunctionPermissionForDto.model';
import { navigation } from 'src/app/app-navigation';

@Injectable()
export class AuthRoleFunctionsService extends ServiceBase {

  baseUrl = environment.apiUrl + 'AuthRoleFunctions/';

  constructor(private http: HttpClient) {
    super();
  }

  // 1.4.1 取得單一角色所擁有的權限
  getAuthRoleFunctionsService(model: UseRoleIDModel) {
    return this.http.post(this.baseUrl + 'data', model, { headers: this.requestHeaders() })
    .pipe(catchError((err) => { return throwError(() => err); })); // .catch(this.handleError);
  }

  // 1.4.2 調整單一角色所擁有的權限
  updateAuthRoleFunctionsService(model: UpdateRoleFunctionsModel[]) {
    return this.http.post(this.baseUrl + 'edit', model, { headers: this.requestHeaders() })
    .pipe(catchError((err) => { return throwError(() => err); })); // .catch(this.handleError);
  }

  // 1.4.3 取得所有功能清單
  getFuctionsService() {
    return this.http.get(this.baseUrl + 'list' , { headers: this.requestHeaders() })
    .pipe(catchError((err) => { return throwError(() => err); })); // .catch(this.handleError);
  }

  // 1.4.4 取得使用者功能權限值
  getUserFunctionPermissionsService(model: UseUserIDModel) {
    return this.http.get(this.baseUrl + 'list' + '/' + model.UserID, { headers: this.requestHeaders() })
    .pipe(catchError((err) => { return throwError(() => err); })); // .catch(this.handleError);
  }

  setAuth(authResult: GetUserFunctionPermissionModel[]) {
    console.log('setAuth', authResult);
    localStorage.setItem('Auth', JSON.stringify(authResult));
  }

  getAuth() {
    return localStorage.getItem('Auth')?.toString();
  }

  checkAuth(functionID: string) {
    const auth = this.getAuth();
    let result = <GetUserFunctionPermissionModel[]>JSON.parse(auth!);
    return result.some(x => x.FunctionId === functionID);
  }

  getFunctionIDFromPath(path: string): string {
    const navItem = navigation.find(item =>  {
      const regex = new RegExp(`^${item.path}(/|$)`);
      return regex.test(path);
    });
    return navItem ? navItem.FunctionId : "";
  }

}
